import { HANDLE_COMPANY, RESET } from '../actions';

const initialState = {
    company: [],    
    search: ""
};

const Company = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_COMPANY:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default Company;